import { Controller } from "@hotwired/stimulus";

// Opens the link in a named popup window (the search page's Dev link opens the dev panel beside it).
export default class extends Controller {
  static values = { name: String, features: String };

  open(event) {
    event.preventDefault();
    window.open(this.element.href, this.nameValue, this.featuresValue);
  }
}
